import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { ModalTerms } from "../../components/ModalTerms";
import { CustomerBasicFields } from "../../components/CustomerBasicFields";
import { CustomerAddressFields } from "../../components/CustomerAddressFields";
import { useOrder } from "../../hooks/useOrder";
import { useCustomerForm } from "../../hooks/useCustomerForm";
import { useFormValidation } from "../../hooks/useFormValidation";
import { useCepService } from "../../hooks/useCepService";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { cnpj, cpf } from "cpf-cnpj-validator";

import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import { Slide, toast } from "react-toastify";
import api from "../../services/api";
import {
  cepNoMask,
  cpfCnpjNoMask,
  dateBRToDateISO,
  datetimeToDateBR,
  rtcToText,
  telephoneNoMask,
} from "../../functions/mask";
import { usePluginspace } from "../../hooks/usePluginspace";
import { CustomerType } from "../../contexts/OrderContext";
import { useFoodConfig } from "../../hooks/useFood";
import { ModalConfirmWpp } from "../../components/ModalConfirmWpp";
import { useCustomerHandlers } from "./ProcessadorCustomer";
import NewModalWhatsApp from "../../components/newModalWhatsApp/newModalWhatsApp";

type configField = {
  visible: boolean;
  mandatory: boolean;
  name: string;
  fieldName: string;
};

export function Customer() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const {
    getCustomer,
    setCustomer,
    getType,
    getOrderAddress,
    synchronizeContextToStorage,
    getCustomerAdress,
    changeCustomerDocument,
  } = useOrder();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const orderContext = useOrder();
  const [pluginspace, setPluginspace] = useState<any>({});
  const [openNewModalWpp, setOpenNewModalWpp] = useState(false);

  // Custom hooks
  const customerForm = useCustomerForm();
  const formValidation = useFormValidation();
  const { findCep } = useCepService({
    setIbge: customerForm.setIbge,
    setCity: customerForm.setCity,
    setAddress: customerForm.setAddress,
    setDistrict: customerForm.setDistrict,
    setState: customerForm.setState,
    setNumber: customerForm.setNumber,
    setComplement: customerForm.setComplement,
  });

  const [useWpp, setUseWpp] = useState(false);
  const [typePluginSpace, setTypePluginSpace] = useState("");


  const [openTerms, setOpenTerms] = useState(false);

  const { customerName, customerPhone } = useFoodConfig();

  const [term, setTerm] = useState("");

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  const [acceptTerm, setAcceptTerm] = useState(false);
  const [type, setType] = useState("");

  const [hideMenu, setHideMenu] = useState(false);

  const [selectedDoc, setSelectedDoc] = useState("cpf");
  const [inscEstadual, setInscEstadual] = useState("");

  //Tem FieldConfig? (Se não tiver continua igual, se tiver montar de acordo com as configurações)
  const [haveFieldConfig, setHaveFieldConfig] = useState(false);
  const [fieldsConfig, setFieldsConfig] = useState<configField[]>([]);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [documentBlocked, setDocumentBlocked] = useState("");
  const [wppAvaiable, setWppAvaiable] = useState(false);

  const [openConfirmWpp, setOpenConfirmWpp] = useState(false);
  const [codeWpp, setCodeWpp] = useState("");
  const [confirmWpp, setConfirmWpp] = useState(false);

  const [customerId, setCustomerId] = useState<string | undefined>();
  const [customerValidationRegister, setCustomerValidationRegister] =
    useState(false);
  const [confirmValidationRegister, setConfirmValidationRegister] =
    useState(false);

  useEffect(() => {
    registerAccess("customer");
    getConfig();
  }, []);

  async function loadOrder() {
    await getToken();
    const customer = await getCustomer();

    // if (customer.wppNotification) setUseWpp(customer.wppNotification);
    if (customer.name) {
      customerForm.setName(customer.name);
    } else if (customerName) {
      customerForm.setName(customerName);
    }
    if (customer.email) customerForm.setEmail(customer.email);
    if (customer.cpf) customerForm.setCpfOrCnpj(customer.cpf);
    if (customer.birthdate) customerForm.setBirthdate(customer.birthdate);
    if (customer.gender) customerForm.setGender(customer.gender);
    if (customer.telephone) {
      customerForm.setTelephone(customer.telephone);
    } else if (customerPhone) {
      customerForm.setTelephone(customerPhone);
    }
    if (customer.cep) customerForm.setCep(customer.cep);
    if (customer.address) customerForm.setAddress(customer.address);
    if (customer.district) customerForm.setDistrict(customer.district);
    if (customer.city) customerForm.setCity(customer.city);
    if (customer.state) customerForm.setState(customer.state);
    if (customer.number) customerForm.setNumber(customer.number);
    if (customer.complement) customerForm.setComplement(customer.complement);
    if (customer.ibge) customerForm.setIbge(customer.ibge);
    if (customer.inscEstadual)
      customerForm.setInscEstadual(customer.inscEstadual);
    if (customer.id) setCustomerId(customer.id.toString());
    if (customer.validateRegister)
      setCustomerValidationRegister(customer.validateRegister);

    const newType = await getType();
    setType(newType);
    const typePlugin = await getThisPluginspace();
    setPluginspace(typePlugin);

    setTypePluginSpace(typePlugin!.type);
  }

  async function verifyWppToOpen() {
    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);

    try {
      const response = await api.get(
        `/api/zapnis-web/sendCodeConfirm/55${telephoneNoMask(
          customerForm.telephone
        )}@us`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutId);
      setLoading(false);
      if (response.data.code) {
        setCodeWpp(window.atob(response.data.code));
        setOpenConfirmWpp(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Falha ao enviar código de confirmação para o seu celular",
        });
      }
    } catch (error) {
      setUseWpp(false);
      toast.error("Falha ao enviar código de confirmação para o seu celular", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
      setLoading(false);
    }
  }

  async function verifyStatusWhatsapp() {
    try {
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 234,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.data[0].content.able === "1") {
            setWppAvaiable(true);
            return;
          } else setWppAvaiable(false);
        })
        .catch((err) => {
          console.log(err);
          setWppAvaiable(false);
        });
    } catch (error) {
      console.log(error);
      setWppAvaiable(false);
    }
  }

  async function getOrderAddressNew() {
    const typeStorage = await getType();
    const orderAddressStorage = await getOrderAddress();
    if (typeStorage === "delivery") {
      if (orderAddressStorage.city !== undefined)
        customerForm.setCity(orderAddressStorage.city);
      if (orderAddressStorage.address !== undefined)
        customerForm.setAddress(orderAddressStorage.address);
      if (orderAddressStorage.district !== undefined)
        customerForm.setDistrict(orderAddressStorage.district);
      if (orderAddressStorage.cep !== undefined)
        customerForm.setCep(orderAddressStorage.cep);
      if (orderAddressStorage.number !== undefined)
        customerForm.setNumber(orderAddressStorage.number);
      if (orderAddressStorage.state !== undefined)
        customerForm.setState(orderAddressStorage.state);
      if (orderAddressStorage.telephone !== undefined) {
        if (orderAddressStorage.telephone.length >= 11) {
          customerForm.setMaskTelephone("(99) 99999-9999");
        } else {
          customerForm.setMaskTelephone("(99) 9999-9999");
        }
        customerForm.setTelephone(orderAddressStorage.telephone);
      }
    } else {
      const endereco = await getCustomerAdress();
      await findCep(endereco.cep, true);
      customerForm.setCep(endereco.cep);
    }
  }

  async function getFieldConfig() {
    const fieldConfig = await api
      .get(`/api/fieldconfig`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        return response.data.data[0];
      })
      .catch((err) => {
        console.log(err.data);
        return err;
      });

    setHaveFieldConfig(fieldConfig ? true : false);

    if (fieldConfig) {
      const data: configField[] = [];
      const regexPattern = new RegExp("true");

      Object.entries(fieldConfig.content).map((fieldConfig: any) => {
        data.push({
          visible: regexPattern.test(fieldConfig[1].visible),
          name: fieldConfig[0],
          fieldName: fieldConfig[1].name,
          mandatory: regexPattern.test(fieldConfig[1].mandatory),
        });
      });

      setFieldsConfig(data);
    }
  }

  async function loadCustomer() {
    const customerDocumento = await orderContext.getCustomerDocument();

    if (customerDocumento) {
      customerForm.setCpfOrCnpj(customerDocumento!);
      await findCustomer2(customerDocumento);
    }
  }

  async function getConfig() {
    setLoading(true);
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await verifyStatusWhatsapp();
    await synchronizeContextToStorage();
    await getOrderAddressNew();
    await getFieldConfig();
    await loadOrder();
    await getTerms();
    await loadCustomer();
    setLoading(false);
  }

  const updateCartWithCustomer = async () => {
    if (orderContext.shouldUpdadeCart) {
      const link = `${window.location.origin}/${window.location.pathname.split("/")[1]
        }/cart`;

      if (orderContext.guidCart) {
        //update
        /*
        1- Recuperar o carrinho pelo guidCart
        2- Atualizar Produtos, endereços Type e Freight
        */

        let customerCart: any = {};

        const tokenAccess = await getToken();
        const newOrder = await orderContext.getOrder();

        setLoading(true);

        await api
          .get(`/api/customerCart/guid/${orderContext.guidCart}`, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => {
            customerCart = response.data.data[0];
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
        const objCustomerCart = {
          customerName: customerForm.name,
          cpfCustomer: cpfCnpjNoMask(customerForm.cpfOrCnpj),
          phoneCustomer: telephoneNoMask(customerForm.telephone),
          jsonCart: customerCart.jsonCart,
          locationId: customerCart.locationId,
          guid: customerCart.guidCart,
        };

        objCustomerCart.jsonCart.products = newOrder!.products;

        await api
          .put(`/api/customerCart/${customerCart.id}`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => { })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });

        setLoading(false);

        return;
      }

      return;
    }
  };

  async function getTermsTotvs() {
    return await api
      .get(`/api/letter-consent`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const totvsRes = response.data;
        if (totvsRes && totvsRes.data && totvsRes.data.body) {
          setTerm(rtcToText(totvsRes.data.body));
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  async function getTerms() {
    const hasTotvsTerms = await getTermsTotvs();
    if (!hasTotvsTerms) {
      await api
        .post(
          `/api/consent/filter`,
          {
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setTerm(response.data.data[0].content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function verify(verify: boolean, valor: string) {
    /* 
      Regra : 
      Se é obrigatoria verifica se o valor é diferente de vazio || ""
      caso n for obrigatorio retorne true
    */

    if (verify) {
      //verifica se o campo foi escrito ou não
      return valor !== "" ? true : false;
    }
    return true;
  }

  function shouldChangeOrderAddressCEP(customer: any) {
    if (
      typePluginSpace === "fashion" &&
      customer.shouldChangeAdressResultFashion
    ) {
      localStorage.setItem(
        "shouldChangeAddressFashion",
        customer.shouldChangeAdressResultFashion
      );
    }
  }

  function isDocumentBlocked(): boolean {
    if (
      documentBlocked === cpfCnpjNoMask(customerForm.cpfOrCnpj) &&
      customerForm.cpfOrCnpj !== "" &&
      !customerForm.cpfOrCnpj.includes("_")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: `Este usuário está bloqueado`,
      });
      customerForm.clearAllCustomer();
      return true;
    }
    return false;
  }

  const handlers = useCustomerHandlers(
    customerForm,
    setLoading,
    setCustomer,
    shouldChangeOrderAddressCEP,
    updateCartWithCustomer,
    navigate,
    pluginspace_id,
    getToken
  );

  async function continueOrder() {
    // Verificar se documento está bloqueado
    if (isDocumentBlocked()) return;

    const isFood = typePluginSpace === "food";

    try {
      if (haveFieldConfig && isFood) {
        await handlers.handleFoodWithFieldConfig(
          fieldsConfig,
          type,
          useWpp,
          inscEstadual,
          config,
          getOrderAddress
        );
      } else if (isFood) {
        await handlers.handleFoodWithoutFieldConfig(
          type,
          useWpp,
          inscEstadual,
          config,
          getOrderAddress
        );
      } else if (haveFieldConfig) {
        await handlers.handleWithFieldConfig(
          fieldsConfig,
          type,
          useWpp,
          inscEstadual,
          config,
          getOrderAddress,
          findCep
        );
      } else {
        await handlers.handleWithoutFieldConfig(
          type,
          useWpp,
          inscEstadual,
          config,
          getOrderAddress,
          findCep,
          customerValidationRegister
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Erro ao processar pedido:", error);
    }
  }

  function readTerms() {
    setOpenTerms(true);
  }

  function changeTelephone(newPhone: string) {
    const phoneValidated = newPhone.replaceAll("_", "");
    if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
      customerForm.setMaskTelephone("(99) 99999-9999");
    } else {
      customerForm.setMaskTelephone("(99) 9999-9999");
    }
  }

  async function findCustomer() {
    if (
      customerForm.cpfOrCnpj === undefined ||
      customerForm.cpfOrCnpj[0] === "_" ||
      (customerForm.selectedDoc === "cpf" &&
        !cpf.isValid(customerForm.cpfOrCnpj)) ||
      (customerForm.selectedDoc === "cnpj" &&
        !cnpj.isValid(customerForm.cpfOrCnpj))
    ) {
      formValidation.setAlarmCpf(true);
    } else {
      formValidation.setAlarmCpf(false);
    }
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(customerForm.cpfOrCnpj);
    changeCustomerDocument(cpfWithouthMask);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          if (
            (data.customerStatus && data.customerStatus === "Bloqueado") ||
            (data.status && data.status === "blocked")
          ) {
            setDocumentBlocked(data.doc);
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "Seu cadastro está inativo. Entre em contato com a loja.",
            });
            customerForm.clearAllCustomer();
            return;
          }

          if (data.name) formValidation.setAlarmName(false);
          else formValidation.setAlarmName(true);
          customerForm.setName(data.name);

          if (data.id) setCustomerId(data.id);

          if (data.validateRegister)
            setCustomerValidationRegister(data.validateRegister);

          if (data.email) formValidation.setAlarmEmail(false);
          else formValidation.setAlarmEmail(true);
          customerForm.setEmail(data.email);

          if (data.birthDate) {
            formValidation.setAlarmBirthdate(false);
            customerForm.setBirthdate(datetimeToDateBR(data.birthDate));
          } else formValidation.setAlarmBirthdate(true);

          if (data.gender) {
            customerForm.setGender(data.gender.toLowerCase());
          } else {
            customerForm.setGender("masculino");
          }

          if (data.inscEstadual) {
            customerForm.setInscEstadual(data.inscEstadual);
          }

          if (
            data.customerPhones[data.customerPhones.length - 1].numberPhone
              .length >= 11
          ) {
            customerForm.setMaskTelephone("(99) 99999-9999");
          } else {
            customerForm.setMaskTelephone("(99) 9999-9999");
          }

          if (data.customerPhones[data.customerPhones.length - 1].numberPhone)
            formValidation.setAlarmTelephone(false);
          else formValidation.setAlarmTelephone(true);
          customerForm.setTelephone(data.customerPhones[0].numberPhone);

          if (data.customerAddresses[data.customerAddresses.length - 1].zipCode)
            formValidation.setAlarmCep(false);
          else formValidation.setAlarmCep(true);
          customerForm.setCep(
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          ) {
            await findCep(
              data.customerAddresses[data.customerAddresses.length - 1].zipCode,
              true
            );
          }
          if (data.customerAddresses[data.customerAddresses.length - 1].street)
            formValidation.setAlarmAddress(false);
          else formValidation.setAlarmAddress(true);
          customerForm.setAddress(
            data.customerAddresses[data.customerAddresses.length - 1].street
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].number)
            formValidation.setAlarmNumber(false);
          else formValidation.setAlarmNumber(true);
          customerForm.setNumber(
            data.customerAddresses[data.customerAddresses.length - 1].number
          );

          customerForm.setComplement(
            data.customerAddresses[data.customerAddresses.length - 1].extra
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].district
          )
            formValidation.setAlarmDistrict(false);
          else formValidation.setAlarmDistrict(true);
          customerForm.setDistrict(
            data.customerAddresses[data.customerAddresses.length - 1].district
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].city)
            formValidation.setAlarmCity(false);
          else formValidation.setAlarmCity(true);
          customerForm.setCity(
            data.customerAddresses[data.customerAddresses.length - 1].city
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].state)
            formValidation.setAlarmState(false);
          else formValidation.setAlarmState(true);
          customerForm.setState(
            data.customerAddresses[data.customerAddresses.length - 1].state
          );
        } else {
          customerForm.clearCustomer();
        }
      })
      .catch((err) => {
        customerForm.clearCustomer();
        setLoading(false);
        console.log(err);
      });
  }

  async function findCustomer2(documento: string) {
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(documento);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          const documento = data.doc.replace(/\D/g, "");

          if (documento.length > 11) {
            customerForm.setSelectedDoc("cnpj");
            customerForm.setInscEstadual(data.inscEstadual);
            customerForm.setMaskCpfjCnpj('99.999.999/9999-99')
          }

          if (data.name) formValidation.setAlarmName(false);
          else {
            formValidation.setAlarmName(true);
          }
          customerForm.setName(data.name);

          if (data.email) formValidation.setAlarmEmail(false);
          else formValidation.setAlarmEmail(true);
          customerForm.setEmail(data.email);

          if (data.birthDate && data.birthDate != null)
            formValidation.setAlarmBirthdate(false);
          else formValidation.setAlarmBirthdate(true);
          customerForm.setBirthdate(
            datetimeToDateBR(data.birthDate ? data.birthDate : "")
          );

          if (data.gender) {
            customerForm.setGender(data.gender.toLowerCase());
          } else {
            customerForm.setGender("masculino");
          }

          if (data.inscEstadual) {
            customerForm.setInscEstadual(data.inscEstadual);
          }

          if (data.validateRegister)
            setCustomerValidationRegister(data.validateRegister);

          if (
            data.customerPhones[data.customerPhones.length - 1].numberPhone
              .length >= 11
          ) {
            customerForm.setMaskTelephone("(99) 99999-9999");
          } else {
            customerForm.setMaskTelephone("(99) 9999-9999");
          }

          if (data.customerPhones[data.customerPhones.length - 1].numberPhone)
            formValidation.setAlarmTelephone(false);
          else formValidation.setAlarmTelephone(true);
          customerForm.setTelephone(data.customerPhones[0].numberPhone);

          if (data.customerAddresses[data.customerAddresses.length - 1].zipCode)
            formValidation.setAlarmCep(false);
          else formValidation.setAlarmCep(true);
          customerForm.setCep(
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          ) {
            await findCep(
              data.customerAddresses[data.customerAddresses.length - 1].zipCode,
              true
            );
          }
          if (data.customerAddresses[data.customerAddresses.length - 1].street)
            formValidation.setAlarmAddress(false);
          else formValidation.setAlarmAddress(true);
          customerForm.setAddress(
            data.customerAddresses[data.customerAddresses.length - 1].street
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].number)
            formValidation.setAlarmNumber(false);
          else formValidation.setAlarmNumber(true);
          customerForm.setNumber(
            data.customerAddresses[data.customerAddresses.length - 1].number
          );

          customerForm.setComplement(
            data.customerAddresses[data.customerAddresses.length - 1].extra
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].district
          )
            formValidation.setAlarmDistrict(false);
          else formValidation.setAlarmDistrict(true);
          customerForm.setDistrict(
            data.customerAddresses[data.customerAddresses.length - 1].district
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].city)
            formValidation.setAlarmCity(false);
          else formValidation.setAlarmCity(true);
          customerForm.setCity(
            data.customerAddresses[data.customerAddresses.length - 1].city
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].state)
            formValidation.setAlarmState(false);
          else formValidation.setAlarmState(true);
          customerForm.setState(
            data.customerAddresses[data.customerAddresses.length - 1].state
          );
        } else {
          customerForm.clearCustomer();
        }
      })
      .catch((err) => {
        customerForm.clearCustomer();
        setLoading(false);
        console.log(err);
      });
  }

  function createFieldDinamycally(data: configField) {
    switch (data.name) {
      case "nome":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>{data.fieldName}</label>
                <input
                  className={`${formValidation.alarmName && "alarm-input"}`}
                  type="text"
                  value={customerForm.name}
                  onChange={(event) => customerForm.setName(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    customerForm.setName(
                      customerForm.name.replaceAll("  ", " ")
                    );
                    setHideMenu(false);
                    (customerForm.name === undefined ||
                      customerForm.name === "") &&
                      data.mandatory
                      ? formValidation.setAlarmName(true)
                      : formValidation.setAlarmName(false);
                  }}
                />
                {formValidation.alarmName && (
                  <p className="alarm-text">Informe um {data.fieldName}</p>
                )}
              </div>
            )}
          </>
        );
      case "email":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>E-mail</label>
                <input
                  className={`${formValidation.alarmEmail && "alarm-input"}`}
                  type="email"
                  value={customerForm.email}
                  onChange={(event) =>
                    customerForm.setEmail(event.target.value)
                  }
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    (customerForm.email === undefined ||
                      customerForm.email === "" ||
                      !customerForm.email.includes("@")) &&
                      data.mandatory
                      ? formValidation.setAlarmEmail(true)
                      : formValidation.setAlarmEmail(false);
                  }}
                />
                {formValidation.alarmEmail && (
                  <p className="alarm-text">Informe um e-mail válido</p>
                )}
              </div>
            )}
          </>
        );
      case "dataNascimento":
        return (
          <>
            {data.visible && customerForm.selectedDoc !== "cnpj" && (
              <div className="input">
                <label>Data de Nascimento</label>
                <InputMask
                  className={`${formValidation.alarmBirthdate && "alarm-input"
                    }`}
                  mask={"99/99/9999"}
                  placeholder="XX/XX/XXXX"
                  type="text"
                  value={customerForm.birthdate}
                  onChange={(event) =>
                    customerForm.setBirthdate(event.target.value)
                  }
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    (customerForm.birthdate === undefined ||
                      customerForm.birthdate === "" ||
                      customerForm.birthdate[1] === "_") &&
                      data.mandatory
                      ? formValidation.setAlarmBirthdate(true)
                      : formValidation.setAlarmBirthdate(false);
                  }}
                />
                {formValidation.alarmBirthdate && (
                  <p className="alarm-text">Informe uma data de nascimento</p>
                )}
              </div>
            )}
          </>
        );
      case "genero":
        return (
          <>
            {data.visible && customerForm.selectedDoc !== "cnpj" && (
              <div className="input">
                <label>Gênero</label>
                <select
                  onChange={(e) => customerForm.setGender(e.target.value)}
                  value={customerForm.gender}
                >
                  <option value="masculino">Masculino</option>
                  <option value="feminino">Feminino</option>
                  <option value="none">Não Informar</option>
                </select>
              </div>
            )}
          </>
        );
      case "telefone":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>Telefone do cadastro</label>
                <InputMask
                  className={`${formValidation.alarmTelephone && "alarm-input"
                    }`}
                  mask={customerForm.maskTelephone}
                  placeholder="DDD + Telefone"
                  type="text"
                  value={customerForm.telephone}
                  onBeforeInputCapture={(event) =>
                    changeTelephone(event.currentTarget.value)
                  }
                  onChange={(event) =>
                    customerForm.setTelephone(event.target.value)
                  }
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    customerForm.telephone[1] === "_" && data.mandatory
                      ? formValidation.setAlarmTelephone(true)
                      : formValidation.setAlarmTelephone(false);
                  }}
                />
                {formValidation.alarmTelephone && (
                  <p className="alarm-text">Informe o telefone</p>
                )}
              </div>
            )}
          </>
        );
    }
  }

  async function saveOrderContext() {
    const orderToStorage = Object.assign(orderContext);
    if (orderToStorage.order !== undefined) {
      await orderContext.encryptOrderStorage(orderToStorage);
    }
  }

  return (
    <div className="customer">
      <div className="content-customer">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: `calc(100vh)` }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="customer-body">
            <h2>Cadastro</h2>
            <div className="group-input">
              {config?.content.pdv.allowSellCnpj && (
                <div className="input">
                  <div className="input-radio">
                    <label className="label-row">
                      <input
                        type="radio"
                        name="radio-doc"
                        value={"cpf"}
                        checked={customerForm.selectedDoc === "cpf"}
                        onChange={(e) => {
                          customerForm.setSelectedDoc(e.target.value);
                          customerForm.setMaskCpfjCnpj("999.999.999-99");
                          customerForm.setCpfOrCnpj("");
                          customerForm.clearAllCustomer();
                        }}
                      />
                      <span>CPF</span>
                    </label>
                    <label className="label-row" style={{ marginLeft: 12 }}>
                      <input
                        type="radio"
                        name="radio-doc"
                        value={"cnpj"}
                        checked={customerForm.selectedDoc === "cnpj"}
                        onChange={(e) => {
                          customerForm.setSelectedDoc(e.target.value);
                          customerForm.setMaskCpfjCnpj("99.999.999/9999-99");
                          customerForm.setCpfOrCnpj("");
                          customerForm.clearAllCustomer();
                        }}
                      />
                      <span>CNPJ</span>
                    </label>
                  </div>
                </div>
              )}
              <div className="input">
                <label>
                  {customerForm.selectedDoc === "cpf" ? "CPF" : "CNPJ"}
                </label>
                <InputMask
                  className={`${formValidation.alarmCpf && "alarm-input"}`}
                  mask={customerForm.maskCpfjCnpj}
                  type="text"
                  value={customerForm.cpfOrCnpj}
                  onChange={(event) =>
                    customerForm.setCpfOrCnpj(event.target.value)
                  }
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    findCustomer();
                  }}
                />
                {formValidation.alarmCpf && (
                  <p className="alarm-text">
                    Informe um{" "}
                    {customerForm.selectedDoc === "cpf" ? "CPF" : "CNPJ"} válido
                  </p>
                )}
              </div>
              {customerForm.selectedDoc === "cnpj" && (
                <div className="input">
                  <label>Inscrição Estadual</label>
                  <input
                    type="text"
                    value={customerForm.inscEstadual}
                    onChange={(event) =>
                      customerForm.setInscEstadual(event.target.value)
                    }
                    onFocus={() => setHideMenu(true)}
                    onBlur={() => {
                      setHideMenu(false);
                    }}
                  />
                </div>
              )}

              {/* Configurar se tem ou não as configurações de Field */}
              <>
                <CustomerBasicFields
                  {...customerForm}
                  {...formValidation}
                  maskTelephone={customerForm.maskTelephone}
                  changeTelephone={changeTelephone}
                  setHideMenu={setHideMenu}
                  haveFieldConfig={haveFieldConfig}
                  fieldsConfig={fieldsConfig}
                  createFieldDinamycally={createFieldDinamycally}
                  isCNPJ={customerForm.selectedDoc === "cnpj"}
                />
              </>
              <>
                {
                  // Se tipo Food e retirada(withdraw) n é para mostrar os campos de entr
                  typePluginSpace !== "food" && (
                    <CustomerAddressFields
                      {...customerForm}
                      {...formValidation}
                      setHideMenu={setHideMenu}
                      findCep={findCep}
                    />
                  )
                }
              </>
            </div>
            {wppAvaiable && (
              <div className="wpp-notification">
                <div className="icon">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 25.8516C0.634451 24.0954 1.19841 22.55 1.76236 21.0045C2.11484 20.2318 2.04433 19.5995 1.62137 18.8268C-2.96078 10.2566 3.24275 -0.0698915 13.0415 0.000356456C19.386 0.000356456 24.8846 4.84747 25.7305 11.1698C26.8584 19.3888 20.0204 26.4838 11.7021 25.6409C10.4332 25.5004 9.09376 25.0086 7.89535 24.5169C7.11991 24.2359 6.48548 24.0954 5.71004 24.3764C4.08867 24.8681 2.4673 25.2896 0.91642 25.7111C0.634442 25.7111 0.422967 25.7111 0 25.8516ZM16.3547 19.8103C17.9056 19.8103 19.0335 19.1078 19.5975 18.1243C20.2319 17.0004 20.0204 16.1574 18.822 15.5252C18.6105 15.3847 18.3286 15.2442 18.0466 15.1739C16.3547 14.3309 16.3547 14.2607 15.2268 15.7359C14.8038 16.2979 14.3809 16.3681 13.8169 16.0169C12.1955 15.1739 10.9266 13.9797 9.93971 12.5045C9.51675 11.8723 9.44623 11.3103 10.0102 10.678C10.4332 10.1863 10.7152 9.62433 10.4332 8.92185C10.0807 8.07887 9.79871 7.2359 9.44624 6.46317C9.23476 5.90119 8.8118 5.69045 8.17735 5.76069C6.69696 5.97144 5.35757 8.14913 5.71004 9.69458C6.69696 13.5582 9.09378 16.3681 12.407 18.4053C13.7464 19.2483 15.0858 19.74 16.3547 19.8103Z"
                      fill="#636363"
                    />
                  </svg>
                </div>
                <div className="info">
                  <p>
                    Aceito ser comunicado via WhatsApp sobre promoções, status
                    de pedidos
                  </p>

                  <div className="options">
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === true}
                        onChange={() => {
                          setUseWpp(true)
                          setOpenNewModalWpp(true)
                        }}
                      />
                      <label>Aceito</label>
                    </div>
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === false}
                        onChange={() => setUseWpp(false)}
                      />
                      <label>Não aceito</label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="button-continue">
              {acceptTerm || !config?.content.pdv.termsActive ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar"
                  onClick={() => {
                    continueOrder()
                  }}
                />
              ) : (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Termos de Consentimento"
                  onClick={readTerms}
                />
              )}
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            hide={hideMenu}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {openConfirmWpp && (
          <ModalConfirmWpp
            isOpen={openConfirmWpp}
            setIsOpen={setOpenConfirmWpp}
            code={codeWpp}
            setConfirm={setConfirmWpp}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            customerId={customerId}
            setConfirmValidationRegister={setConfirmValidationRegister}
          />
        )}
        {openNewModalWpp && pluginspace.phoneContact && (
          <NewModalWhatsApp
            isOpen={openNewModalWpp}
            setIsOpen={setOpenNewModalWpp}
            backgroundButton={
              config?.webappcolor.webappbutton && config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            whatNumber={pluginspace.phoneContact}
            pluginName={pluginspace.name}
          />
        )}
        {openTerms && (
          <ModalTerms
            isOpen={openTerms}
            setIsOpen={setOpenTerms}
            termContent={term}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            acceptTerm={acceptTerm}
            setAcceptTerm={setAcceptTerm}
          />
        )}
      </div>
    </div>
  );
}
